import { HttpClient } from '@angular/common/http';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input
} from '@angular/core';
import { IonContent, Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { LocationSuggestion } from 'src/app/services/enode/enode.types';

@Component({
  selector: 'app-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss']
})
export class LocationPickerComponent implements OnInit {
  @Input() locationSuggestions: LocationSuggestion[];
  @Input() parentContent?: IonContent;
  @Output() emitCloseMap = new EventEmitter<boolean>();
  @Output() emitSelectedLocation =
    new EventEmitter<google.maps.places.PlaceResult>();

  markerPosition = new Set<google.maps.LatLngLiteral>();
  selectedLocation: google.maps.places.PlaceResult;
  autoCompleteSuggestions: google.maps.places.PlaceResult;
  selectedLocationLatLng: google.maps.LatLngLiteral;
  autoComplete: google.maps.places.Autocomplete;
  locationName: string;
  isNameSet = false;
  width: number;
  height: number;
  shrinkInput = true;

  @ViewChild('placeSearch') inputField: ElementRef<HTMLInputElement>;
  constructor(_httpClient: HttpClient, private platform: Platform) {}

  ngOnInit() {
    if (this.platform.width() < 500) {
      this.height = this.width = this.platform.width() - 40;
      this.shrinkInput = false;
    } else {
      this.height = this.width = 500;
      this.shrinkInput = true;
    }
    if (this.locationSuggestions.length > 0) {
      this.locationSuggestions.forEach((suggestion) => {
        this.markerPosition.add({
          lat: suggestion.latitude,
          lng: suggestion.longitude
        });
      });
    } else {
      // Fallback til kontoret om ingen lokasjonsforslag
      this.markerPosition.add({
        lat: 69.655263,
        lng: 19.01119
      });
    }
  }

  ngAfterViewInit() {
    this.setupAutocomplete();
  }

  setupAutocomplete() {
    this.autoComplete = new google.maps.places.Autocomplete(
      this.inputField.nativeElement,
      {
        componentRestrictions: { country: 'no' },
        fields: ['geometry', 'formatted_address']
      }
    );

    this.autoComplete.addListener('place_changed', () => {
      this.autoCompleteSuggestions = this.autoComplete.getPlace();

      this.inputField.nativeElement.value = '';
    });
  }

  setSelectedLocation(location: google.maps.places.PlaceResult) {
    this.selectedLocation = location;
  }

  submit() {
    this.emitSelectedLocation.emit(this.selectedLocation);
  }

  back() {
    this.emitCloseMap.emit(true);
  }

  scrollToBottom() {
    if (this.parentContent) {
      this.parentContent.scrollToBottom();
    }
  }
}
